import { loadDismissablePrompts } from '@ms/yammer-data/dist/domains/dismissablePrompts/actions';
import type { DismissablePromptKey, DismissablePromptType } from '@ms/yammer-data/dist/state/types';
import { isEventsPage } from '@ms/yammer-web-support/dist/location';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export type UseLoadDismissablePrompts = ({
  promptKeys,
  promptTypes,
}: {
  readonly promptKeys?: DismissablePromptKey[];
  readonly promptTypes?: DismissablePromptType[];
}) => void;

interface LoadDismissablePromptsParams {
  readonly promptKeys: DismissablePromptKey[];
  readonly promptTypes: DismissablePromptType[];
}

export const useLoadDismissablePrompts: UseLoadDismissablePrompts = ({ promptKeys = [], promptTypes = [] }) => {
  const dispatch = useDispatch();
  const isLiveEventPage = isEventsPage(window.location.pathname);

  // Re-derive the dispatch params only when their serialized content actually changes, so the effect below
  // does not re-fire on every render when callers pass new array instances with the same contents.
  const [signature, setSignature] = useState(() => JSON.stringify({ promptKeys, promptTypes }));
  const [params, setParams] = useState<LoadDismissablePromptsParams>({ promptKeys, promptTypes });
  const nextSignature = JSON.stringify({ promptKeys, promptTypes });
  if (signature !== nextSignature) {
    setSignature(nextSignature);
    setParams({ promptKeys, promptTypes });
  }

  useEffect(() => {
    if (isLiveEventPage) {
      return;
    }

    dispatch(loadDismissablePrompts(params));
  }, [dispatch, params, isLiveEventPage]);
};
